import { LikesConfig } from "@energylab/shared-components/constants/config/likesConfig";

export const likesConfig: LikesConfig = {
    disabled: false
};
